import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 12l-8 -8v16l16 -16v16l-4 -4","key":"svg-0"}],["path",{"d":"M20 12l-8 8l-4 -4","key":"svg-1"}]]

/**
 * IconBrandFramerMotion
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhbmQtZnJhbWVyLW1vdGlvbiIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTIgMTJsLTggLTh2MTZsMTYgLTE2djE2bC00IC00IiAvPgogIDxwYXRoIGQ9Ik0yMCAxMmwtOCA4bC00IC00IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/brand-framer-motion
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrandFramerMotion = createReactComponent('outline', 'brand-framer-motion', 'BrandFramerMotion', __iconNode);

export default IconBrandFramerMotion;